import { ephemeralStore } from "../../../store/ephemeral/runtime/ephemeralStore";
import {
    beginPanelDrag,
    commitPanelSnapTier,
    endPanelDragWithoutCommit,
    updatePanelDragHeight,
} from "../../../store/ephemeral/slices/itineraryPanelState.actions";
import { itineraryPanelStateSlice } from "../../../store/ephemeral/slices/itineraryPanelState.slice";
import type { PanelResizeProfileId, PanelResizeStoreAdapter } from "./panelResize.types";

/**
 * Ephemeral-store adapter for the shared itinerary bottom panel resize module.
 */
export const itineraryPanelResizeAdapter: PanelResizeStoreAdapter = {
    getCommittedHeightVh(): number {
        return ephemeralStore.peek( itineraryPanelStateSlice ).itineraryListHeight;
    },

    getLiveDragHeightVh(): number | null {
        return ephemeralStore.peek( itineraryPanelStateSlice ).dragHeightVh;
    },

    beginDrag( startHeightVh: number, profileId: PanelResizeProfileId ): void {
        beginPanelDrag( startHeightVh, profileId );
    },

    updateDragHeight( heightVh: number ): void {
        updatePanelDragHeight( heightVh );
    },

    commitSnapTier( tier, resolvedHeightVh, profileId ): void {
        commitPanelSnapTier( tier, resolvedHeightVh, profileId );
    },

    endDragWithoutCommit(): void {
        endPanelDragWithoutCommit();
    },

    subscribe( listener: () => void ): () => void {
        return ephemeralStore.subscribe( itineraryPanelStateSlice, listener );
    },
};
